import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  HostListener,
  OnChanges,
  AfterViewInit,
  SimpleChanges,
  ViewChild,
  ElementRef
} from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { SharedPopupService } from 'src/app/common/services/shared-popup.service';
import { AlertMessageService } from 'src/app/common/services/alert-message.service';
import { AlertMessageModel, results } from 'src/app/common/models/common.model';
import { DomSanitizer } from '@angular/platform-browser';
import * as _ from 'lodash';
import { AuthenticationService } from 'src/app/common/services/authentication.service';
import { CrosstabService } from 'src/app/common/services/crosstab.service';
// import { LoaderService } from '../../../../../assets/ImagesSnapshot/Public/fourWidget_inactive.jpg'
import { LoaderService } from 'src/app/common/services/loader.service';
import { SnapshotService } from '../../Services/snapshot.service';
import { CustomsnapshotService } from '../../Services/customsnapshot.service';

// Now you can use lodash functions like _.filter


interface Client {
  ClientName: string;
  showStudies: boolean;
  UniqueStudies: string[];
}
@Component({
  selector: 'app-shared-popup-snapshot',
  templateUrl: './shared-popup.component.html',
  styleUrls: ['./shared-popup.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SharedPopupSnapshotComponent implements OnChanges, AfterViewInit {
  @Input() isAdditionalColumn:boolean=false;
  @Input() selectedAdditionalColumnDetails:any=null;
  @Input() trendSamplesizeview:boolean=false;
  @Input() showGlobalDefaultPopup: boolean = false;
  @Output() isSavePopUpVisible = new EventEmitter<any>();
  @Output() isCustomGroupSavePopUpVisible = new EventEmitter<any>();
  @Output() isCustomGroupVisible = new EventEmitter<any>();
  @Output() isCustomGroupShareVisible = new EventEmitter<any>();
  @Output() isShareSelectionVisible = new EventEmitter<any>();
  @Output() SaveSelectionClick = new EventEmitter<any>();
  @Output() ShareSelectionClick = new EventEmitter<any>();
  @Output() SaveCustomSelectionClick = new EventEmitter<any>();
  @Output() saveAdditionalColumnDetails = new EventEmitter<any>();
  @Output() bindSelectedScenario = new EventEmitter<any>();
  @Output() isLoadClickOutput = new EventEmitter<any>();

  @Output() toggle = new EventEmitter<string>();

  @Output() isShowDialog = new EventEmitter<any>();
  @Output() deleteMessage = new EventEmitter<any>();
  //@Output() shareMessage = new EventEmitter<any>();
  @Output() currentSavedScenarioData = new EventEmitter<any>();

  @Output() bindCustomGroupFlags = new EventEmitter<any>();
  // @Output() bindUpdateCustomGroupClick = new EventEmitter<any>();
  @Input() snapshotdata: any;
  @Input() BIPSelectedStatus: boolean = false;
  @Input() isFomChanged: boolean = false;
  @Input() widgetString: string = '';
  @Input() isSaveSelectionClick: boolean = false;
  @Input() isSaveCustomGroupSelectionClick = false;
  @Input() isLoadClick: boolean = false;
  @Input() isCustomGroupClick: boolean = false;
  @Input() showLoaderPopUp: boolean = true;
  @Input() showErrorPopUp: boolean = false;
  @Input()showSubsctionPopup:boolean=true;
  @Input() showConfirmationPopUp: boolean = true;
  @Input() showInputPopUp: boolean = false;
  @Input() showWidgetExpand: boolean = true;
  @Input() showSampleSizePopup: boolean = false;
  @Input() OutputdataObject: any;
  @Input() TrendToggleContainer: boolean = true;
  @Input() TrendToggleOn: boolean = false;
  @Input() isTranspose: boolean = false;
  @Input() isTotalBase: boolean = false;
  @Input() isAnswerBase: boolean = false;
  @Input() isSampleSize: boolean = false;
  @Input() popUpParameter: string = "";
  @Input() popUpMessage: string = "";
  @Input() data!: Client[];
  @Input() isTrendView: boolean = false;
  //@Input() loadSavedScenarioData: any;
  @Input() SnapShotType:any;

  @Input() loadUserDefinedSavedScenarioData: any;
  @Input() loadSharedWithMeSavedScenarioData: any;
  //@Input() loadCustomGroupData: any;
  @Input() loadCustomGroupUserDefinedData: any;
  @Input() loadCustomGroupSharedWithMeData: any;
  @Input() customGroupShareUserList: any;
  @Input() shareSelectionUserList: any;
  @Input() selectedCustomGroupObj: any;
  @Input() isShareCustomGroupPopupClick: boolean = false;
  @Input() isShareSelectionClick: boolean = false;
  @Input() selectedEmailsToShare: string[] = [];
  @Input() selectedLoadSelectionObj: any;
  initialSelectedEmailsToShare:any;
  subsectionName:string='';
  @Input() isChangeOfEntryPointConfigured: boolean = false;
  @Input() showLoadSelection: boolean = false;
  @Input() weightSelectedValue: string = '';
  MainData : any;
  filteredOutputDataObject: any; // Stores filtered output data with NA rows removed
  infoMessage: string = '';
  searchText: string = '';
  updateSummary: any = '';
  selectedCustomGroupName: any = '';
  customGroupId: string = "";
    uploadedMetricRows: any[] = [];
  selectedCustomGroupName_Bucket: string = ''; //user defined or shared
  selectedSelectionName: any = '';
  isUserDefinedListVisible: boolean = false;
  isSharedWithMeListVisible: boolean = false;
  customGroupHeaderText: string = 'Custom Group List';
  selectionName="";
  dontShowAgain: boolean = false;
  selectedFile: File | null = null;
  uploadedMetricDictionary: any = {};

  @ViewChild('hoverTextArea') hoverTextAreaRef!: ElementRef<HTMLDivElement>;
 
  additionalColumnHeader: string = '';
  additionalColumnPosition: string = '';
  additionalColumnHoverText: string = '';
  additionalColumnPositiveValue: string = '';
  additionalColumnNegativeValue: string = '';
  additionalColumnSortingOrder: string = 'ascending';
  combinationOfEntryPoints: string = 'Average';
  isTemplateDownloadClicked: boolean = false;
  readonly decimalNumberPattern: RegExp = /^-?\d+(\.\d+)?$/;
  hideConfiguration: boolean = false;
  isFormDirty: boolean = false;

  private _initialFormState: {
    columnHeader: string;
    columnPosition: string;
    hoverOverText: string;
    positiveValue: string;
    negativeValue: string;
    sortingOrder: string;
    combinationOfEntryPoints: string;  
    hasFile: boolean;
  } | null = null;

 
ngOnChanges(changes: SimpleChanges): void {
  if (changes['selectedAdditionalColumnDetails'] || changes['isAdditionalColumn']) {

    const details = this.selectedAdditionalColumnDetails?.additionalColumnForm || {};
    const selectedColumn = this.selectedAdditionalColumnDetails || {};

    this.additionalColumnHeader =
      details.columnHeader ||
      selectedColumn.columnName ||
      '';

    this.additionalColumnPosition =
      details.columnPosition != null
        ? String(details.columnPosition)
        : '';

    this.additionalColumnHoverText =
      details.hoverOverText || '';

    if (this.hoverTextAreaRef) {
      this.hoverTextAreaRef.nativeElement.innerHTML = this.additionalColumnHoverText;
    }

    this.additionalColumnPositiveValue =
      details.positiveValue || '';

    this.additionalColumnNegativeValue =
      details.negativeValue || '';

    this.additionalColumnSortingOrder =
      details.sortingOrder || 'ascending';

    this.combinationOfEntryPoints =
      details.combinationOfEntryPoints || 'Average';
      

    this.uploadedMetricDictionary = selectedColumn.uploadedMetricDictionary || {};
    this.uploadedMetricRows = selectedColumn.uploadedMetricRows || [];

    this.isTemplateDownloadClicked = false;
    this.selectedFile = null;
    this.isFormDirty = false;
    this._snapshotInitialFormState();
  }
  if (changes['OutputdataObject'] && this.OutputdataObject) {
      this.filteredOutputDataObject = this.filterOutputDataForNA(this.OutputdataObject);
    }
}

ngAfterViewInit(): void {
  if (this.hoverTextAreaRef) {
    this.hoverTextAreaRef.nativeElement.innerHTML = this.additionalColumnHoverText || '';
  }
}



  selectedStudy: string = '';
  selectedClient: string = '';
  filteredData: any[] = [];
  isNavigateButtonDisabled: boolean = true;
  isConfigurationButtonDisabled: boolean = true;
  isAddClientButtonDisabled: boolean = false;
  isStudySelected: boolean = false;
  selectedClientCode: string = '';
  popUpData: any;
  SaveSelection: string = '';
  displayTable: boolean = true;
  userDefinedSelectionQuery: string = '';
  sharedWithMeSelectionQuery: string = '';
  @Input() showMultiFunnelPopup:boolean=false;
  headerTitle: string = 'Save Selection';
  StaticText: string = 'Please enter the selection name (Max 50 characters)';
  showFomChangedMessage: boolean = false;
  dropdownTextBrands = [
    {
      key : "Default",
      dropdownId : 0
    },
    {
      key : "All Metrics for One Brand",
     dropdownId : 1 
    },
    {
      key:"All Brands for One Metric",
      dropdownId : 2
    }
  ]
  dropdownTextMarkets=[
    {
      key : "Default",
      dropdownId : 0
    },
    {
      key : "All Metrics for One Market",
     dropdownId : 1 
    },
    {
      key:"All Markets for One Metric",
      dropdownId : 2
    }
  ]
  dropdownTextAudience=[
    {
      key : "Default",
      dropdownId : 0
    },
    {
      key : "All Audience for One Variable",
     dropdownId : 1 
    },
      {
        key:"All Variable for One Audience",
      dropdownId : 2
    }
  ]
  dropdownText:any=[];
  BaseDropDown:any=[
    {
      id:1,
      base:"Sample Size",
      is_selected : false,
    },
    {
      id:2,
      base:"Weighted Base",
      is_selected: false, 
    },
    {
      id:3,
      base:"Weighted Numerator",
      is_selected: false, 
    },
    {
      id:4,
      base:"Unweighted Numerator",
      is_selected: false, 
    },
  ];
  isNavigationShown: boolean = false;
  isConfigurationShown: boolean = false;
  isUserManagementShown: boolean = false;
  isAddClientStudyShown: boolean = false;
  isUserListToShareDropdownOpen: boolean = false;
  showViewDropDown : boolean = false;
  showBaseViewDropDown : boolean = false;
  dropDownLevel1SelectedKey : String = ""
  dropDownLevel1SelectedId : any;
  dropDownBaseSelectedName : any;
  dropDownBaseSelectedId:any;
  dropDownLevel2 : any = []
  dropDownLevel2SelectedValue : any = "Select";
  showLevel2DropDown : boolean = false;
  defaultShowSampleSize : String = "Single"
  snapShotTypeSelected : any;
  isAudienceType: boolean = false;
  dropDownData : Object = {};
  baseDropDownCss : String = "";
  @Input() isDuplicateCustomGroup: boolean = false;

  filteredEmailsToShare: string[] = [];
  @Output() closePopUp = new EventEmitter<string>();
  @Output() closeErrorPopUp = new EventEmitter<string>();
  @Output() closeSubsectionPopUp=new EventEmitter<any>();
  @Output() closeSamplesizePopUp = new EventEmitter<string>();
  @Output() closeConfirmationPopUp = new EventEmitter<string>();
  columnConfig: any[] = [
    {
      name: 'Selections',
      userDefined_width: '60%',
      imageName: '',
      sharedWithMe_width: '40%',
    },
    {
      name: 'Load',
      userDefined_width: '10%',
      imageClass: 'LoadImage',
      sharedWithMe_width: '10%',
    },
    {
      name: 'Info',
      userDefined_width: '10%',
      imageClass: 'InfoImage',
      sharedWithMe_width: '10%',
    },
    {
      name: 'Delete',
      userDefined_width: '10%',
      imageClass: 'DeleteImage',
      sharedWithMe_width: '10%',
    },
    {
      name: 'Share',
      userDefined_width: '10%',
      imageClass: 'ShareImage',
      sharedWithMe_width: '10%',
    },
  ];
  get hoverTextCharacterCount(): number {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = this.additionalColumnHoverText || '';
    return (tempDiv.textContent || tempDiv.innerText || '').length;
  }
  $unSubscribeSubmitData6: any;
  $unSubscribeSubmitData8: any;
  constructor(
    private msalService: MsalService,
    private router: Router,
    public SharedPopupService: SharedPopupService,
    private _authenticateService: AuthenticationService,
    private _alertService: AlertMessageService,
    private sanitizer: DomSanitizer,
    private crossTabService: CrosstabService,
    private Loader: LoaderService,
    public _configService: SnapshotService,
    private _loaderService: LoaderService,
    private _configCustomService: CustomsnapshotService,
    private _cdr: ChangeDetectorRef
  ) { }


  gridData = [
    { header: 'Header 1', text: 'Content 1' },
    { header: 'Header 2', text: 'Content 2' },
    { header: 'Header 3', text: 'Content 3' },
    { header: 'Header 4', text: 'Content 4' },
    { header: 'Header 5', text: 'Content 5' },
    { header: 'Header 6', text: 'Content 6' },
    { header: 'Header 7', text: 'Content 7' },
    { header: 'Header 8', text: 'Content 8' },
    { header: 'Header 9', text: 'Content 9' },
  ];


  ngOnInit() {
    this.initialSelectedEmailsToShare = [...this.selectedEmailsToShare];
    var sizePercentage = "95%";
    var pixelRatio = window.devicePixelRatio;
    var resolution = `${window.screen.width * window.devicePixelRatio}` + "x" + `${window.screen.height * window.devicePixelRatio}`;

    switch(resolution){
      case "1920x1080":
        if(pixelRatio == 1){
          this.baseDropDownCss = "base-dropdown1"
        }else if(pixelRatio == 1.25){
          this.baseDropDownCss = "base-dropdown2"
        }else if(pixelRatio == 1.75){
          this.baseDropDownCss = "base-dropdown3"
        }else{
          this.baseDropDownCss = "base-dropdown"
        }
        break;
      case "1600x900":
        if(pixelRatio == 1){
          this.baseDropDownCss = "base-dropdown4"
        }else if(pixelRatio == 1.25){
          this.baseDropDownCss = "base-dropdown5"
        }else if(pixelRatio == 1.75){
          this.baseDropDownCss = "base-dropdown6"
        }else{
          this.baseDropDownCss = "base-dropdown"
        }
        break;
      case "1366x768":
        if(pixelRatio == 1){
          this.baseDropDownCss = "base-dropdown7"
        }else if(pixelRatio == 1.25){
          this.baseDropDownCss = "base-dropdown8"
        }else if(pixelRatio == 1.75){
          this.baseDropDownCss = "base-dropdown9"
        }else{
          this.baseDropDownCss = "base-dropdown"
        }
        break;
      case "1280x720":
        if(pixelRatio == 1){
          this.baseDropDownCss = "base-dropdown10"
        }else if(pixelRatio == 1.25){
          this.baseDropDownCss = "base-dropdown11"
        }else if(pixelRatio == 1.75){
          this.baseDropDownCss = "base-dropdown12"
        }else{
          this.baseDropDownCss = "base-dropdown"
        }
        break;
      default:
        this.baseDropDownCss = "base-dropdown"
        break;
    }
    
    if(this._configService.selectedcompareacrossOption.replace(/\s+/g, '').toLowerCase() == "multiplemarkets"){
      this.dropdownText = this.dropdownTextMarkets;
    }
    if(this._configService.selectedcompareacrossOption.replace(/\s+/g, '').toLowerCase() == "multiplebrands"){
      this.dropdownText = this.dropdownTextBrands;
    }
    if(this._configService.selectedcompareacrossOption.replace(/\s+/g, '').toLowerCase() == "audiencesnapshot" && this._configService.multiCohort){
      this.dropdownText = this.dropdownTextAudience;
    }
    this.MainData = _.cloneDeep(this.snapshotdata);
    // Hide reference-only brand rows (sig/index reference not selected in left-panel Brands)
    if (Array.isArray(this.MainData)) {
      this.MainData = this.MainData.filter(
        (row: any) =>
          !this._configService.shouldExcludeColChildFromDisplay(row?.colChild)
      );
    }
    if (this.OutputdataObject) {
      this.filteredOutputDataObject = this.filterOutputDataForNA(
        this.OutputdataObject
      );
    }
    this.snapShotTypeSelected = (this.SnapShotType?.toLowerCase().includes("audience") && this._configService.multiCohort) ? "audience" : this.SnapShotType?.toLowerCase().includes("multiple") ? "multiple" : "single";
    this.isAudienceType = this.SnapShotType?.toLowerCase().includes("audience") && this._configService.multiCohort;
    //if (!this.isLoadClick) this.getPopUpeData();
    this.headerTitle = this.isSaveCustomGroupSelectionClick
      ? 'Save Custom Group'
      : this.headerTitle;
    this.StaticText = this.isSaveCustomGroupSelectionClick
      ? 'Please enter the Custom Group name (Max 50 characters)'
      : this.StaticText;    
    this.dropDownLevel1SelectedKey = this.dropdownText[0]?.key;
    this.dropDownLevel1SelectedId = this.dropdownText[0]?.dropdownId;
    this.showDefaultSelectedWidget();
    this.setDefaultSampleSize()
    
    // Select appropriate default base first
    if (this.isAudienceType || this.SnapShotType?.toLowerCase().includes('audience')) {
      const sampleSizeOption = this.BaseDropDown.find((b: any) => b.id === 1);
      if (sampleSizeOption) {
        this.OnBaseSelected(sampleSizeOption);
      }
    } else {
      // Original behavior for non-audience snapshots
      this.weightSelectedValue != '' ?
        this.weightSelectedValue == "Unweighted" ?
          this.OnBaseSelected(this.BaseDropDown[0]) :
          this.OnBaseSelected(this.BaseDropDown[1]) : 
        this.OnBaseSelected(this.BaseDropDown[0]);
    }  
    // Only apply the unweighted filter when the explicit weight selection is "Unweighted".
    if (this.weightSelectedValue && this.weightSelectedValue.toLowerCase() === 'unweighted') {
      this.BaseDropDown = _.filter(this.BaseDropDown, b => b.id === 1 || b.id === 4);
    }
    this.showFomChangedMessage = this.isFomChanged;
  }

  /**
   * Handle input changes and filter OutputdataObject to remove rows with all NA values
   */
  // ngOnChanges(changes: SimpleChanges) {
  //   if (changes['OutputdataObject'] && this.OutputdataObject) {
  //     this.filteredOutputDataObject = this.filterOutputDataForNA(this.OutputdataObject);
  //   }
  // }

  // @HostListener('document:click', ['$event'])
  // onDocumentClick(event: MouseEvent): void {
  //   if (!this.elementRef.nativeElement.contains(event.target)) {
  //     this.isDropdownOpen = false;
  //   }
  // }

  toggleTrendSample(view: any) {
    this.toggle.emit(view); // Triggers parent method
  }
  setDefaultSampleSize(){
    this.dropDownLevel1SelectedId = 0
    this.dropDownLevel2SelectedValue = "Default View"
    this.dropDownLevel2SelectedValue = "Select"
    // let distinctBrandNames = [...new Set(this.MainData.map((item:any) => item.colChild.split("|")[1]))]
    // distinctBrandNames.forEach( brand => {
    //   let obj : any = {};
    //   obj.name = brand;
    //   obj.is_selected = false;
    //   this.dropDownLevel2.push(obj);
    // })

    // if(this.dropDownLevel2.length > 0){
    //   this.dropDownLevel2[0].is_selected = true;
    // }

    this.dropDownData = {
      dropDownLevel1: this.dropDownLevel1SelectedId,
      dropDownLevel2 : this.dropDownLevel2
    }
  }
  getPopUpeData(): void {
    this.SharedPopupService.setPopUpTabData$.subscribe((data) => {
      if (data != null && data.data.length > 0) {
        //data=this.restrictClientsBasedOnEmailID(data);
        this.popUpData = data.data;
        this.filteredData = data.data;
        this.ShowAccessLevel();
      }
    });
  }
  ShowAccessLevel() {
    let access = this._authenticateService.GetAccess();
    if (access === this._authenticateService.level1) {
      this.isAddClientStudyShown = true;
      this.isUserManagementShown = true;
      this.isConfigurationShown = true;
    }
    if (access === this._authenticateService.level2) {
      this.isUserManagementShown = true;
    }
  }

  // restrictClientsBasedOnEmailID(data: any) {
  //   if (data != null && data.length > 0) {
  //     const accounts = this.msalService.instance.getAllAccounts();
  //     if (accounts != null && accounts.length > 0) {
  //       let userEmail = accounts[0].username;
  //       if (this.emails.indexOf(userEmail.toLowerCase()) == -1) {
  //         this.hideConfiguration = true;
  //         return data.filter((x: any) => {
  //           return x.ClientName == "Demo"
  //         })
  //       }
  //     }
  //   }
  //   return data;
  // }
  closeClick() {
    this.closePopUp.emit('false');
  }
  closeErrorPopUpClick() {
    this.closeErrorPopUp.emit('false');
    this.showErrorPopUp = false;
  }
 onFileSelected(event: any): void {
  if (!this.isTemplateDownloadClicked) {
    this.errorPopup('Please download template first before uploading.', 'Alert');
    event.target.value = '';
    return;
  }

  const file = event.target.files[0];

  if (!file) {
    return;
  }

  const extension = file.name.split('.').pop()?.toLowerCase();

  if (extension !== 'xlsx' && extension !== 'xls') {
    alert('Please upload a valid Excel file.');
    return;
  }

  this.selectedFile = file;

  this.checkFormDirty();
  //this.uploadAttributeImportanceFile();
}

  private _snapshotInitialFormState(): void {
    this._initialFormState = {
      columnHeader: this.additionalColumnHeader,
      columnPosition: this.additionalColumnPosition,
      hoverOverText: this.additionalColumnHoverText,
      positiveValue: this.additionalColumnPositiveValue,
      negativeValue: this.additionalColumnNegativeValue,
      sortingOrder: this.additionalColumnSortingOrder,
      combinationOfEntryPoints: this.combinationOfEntryPoints,
      hasFile: !!this.selectedFile,
    };
  }

  checkFormDirty(): void {
    if (!this._initialFormState) {
      this.isFormDirty = !!this.selectedFile;
      return;
    }
    const s = this._initialFormState;
    this.isFormDirty =
      this.additionalColumnHeader !== s.columnHeader ||
      this.additionalColumnPosition !== s.columnPosition ||
      this.additionalColumnHoverText !== s.hoverOverText ||
      this.additionalColumnPositiveValue !== s.positiveValue ||
      this.additionalColumnNegativeValue !== s.negativeValue ||
      this.additionalColumnSortingOrder !== s.sortingOrder ||
      this.combinationOfEntryPoints !== s.combinationOfEntryPoints ||
      !!this.selectedFile !== s.hasFile;
  }
  

private isValidColumnPosition(): boolean {
  return this.additionalColumnPosition === '1' || this.additionalColumnPosition === '2';
}

private isValidDecimalNumber(value: string): boolean {
  const trimmedValue = (value || '').trim();
  return this.decimalNumberPattern.test(trimmedValue);
}

private validateAdditionalColumnForm(): boolean {
  if (!this.isValidColumnPosition()) {
    this.errorPopup('Column Position can only be 1 or 2.', 'Alert');
    return false;
  }

  if (!this.isValidDecimalNumber(this.additionalColumnPositiveValue)) {
    this.errorPopup('Positive value must be a number or decimal.', 'Alert');
    return false;
  }

  if (!this.isValidDecimalNumber(this.additionalColumnNegativeValue)) {
    this.errorPopup('Negative value must be a number or decimal.', 'Alert');
    return false;
  }

  return true;
}

private buildAttributeImportanceFormData(): FormData {
  const formData = new FormData();

  if (this.selectedFile) {
    formData.append('file', this.selectedFile, this.selectedFile.name);
  }

  formData.append('selectedAdditionalColumnDetails', JSON.stringify(this.selectedAdditionalColumnDetails || {}));
  formData.append(
    'additionalColumnForm',
    JSON.stringify({
      columnHeader: this.additionalColumnHeader,
      columnPosition: this.additionalColumnPosition,
      hoverOverText: this.additionalColumnHoverText,
      positiveValue: this.additionalColumnPositiveValue,
      negativeValue: this.additionalColumnNegativeValue,
      // sortingOrder: this.additionalColumnSortingOrder,          
      combinationOfEntryPoints: this.combinationOfEntryPoints, 
    })
  );
  formData.append('uploadedMetricDictionary', JSON.stringify(this.uploadedMetricDictionary || {}));
  return formData;
}

private parseMetricRowsFromUploadResponse(response: any): any[] {
  try {
    const parsedData = typeof response === 'string' ? JSON.parse(response) : response;
    const metricEntries = Array.isArray(parsedData) ? parsedData : (parsedData?.data ?? []);

    if (Array.isArray(metricEntries)) {
      return metricEntries;
    }

    if (typeof metricEntries === 'string') {
      const parsedMetricEntries = JSON.parse(metricEntries);
      return Array.isArray(parsedMetricEntries) ? parsedMetricEntries : [];
    }

    return [];
  } catch {
    return [];
  }
}

private buildUploadedMetricDictionary(response: any): any {
  // Keep the full upload response dataset exactly as returned by API.
  try {
    return typeof response === 'string' ? JSON.parse(response) : response;
  } catch {
    return response;
  }
}

uploadFile(): void {
  if (!this.isTemplateDownloadClicked) {
    this.errorPopup('Please download template first before uploading.', 'Alert');
    return;
  }

  if (!this.selectedFile) {
    alert('Please select a file first.');
    return;
  }

  const formData = this.buildAttributeImportanceFormData();

  this._configCustomService.
    uploadAttributeImportanceFile(formData)
    .subscribe({
      next: (response) => {
        const metricEntriesArray = this.parseMetricRowsFromUploadResponse(response);
        this.uploadedMetricRows = metricEntriesArray;
        this.uploadedMetricDictionary = this.buildUploadedMetricDictionary(response);
        this._cdr.detectChanges();
      },
      error: (error) => {
        console.error('Upload failed', error);
      }
    });
}

saveAttributeImportanceDetails(): void {
  if (!this.validateAdditionalColumnForm()) {
    return;
  }

  // No new file — emit with existing uploaded data directly
  if (!this.selectedFile) {
    if (!this.uploadedMetricRows || this.uploadedMetricRows.length === 0) {
      alert('Please select a file first.');
      return;
    }
    this.saveAdditionalColumnDetails.emit({
      selectedAdditionalColumnDetails: this.selectedAdditionalColumnDetails,
      additionalColumnForm: {
        columnHeader: this.additionalColumnHeader,
        columnPosition: this.additionalColumnPosition,
        hoverOverText: this.additionalColumnHoverText,
        positiveValue: this.additionalColumnPositiveValue,
        negativeValue: this.additionalColumnNegativeValue,
        sortingOrder: this.additionalColumnSortingOrder,
        combinationOfEntryPoints: this.combinationOfEntryPoints, 
      },
      uploadedMetricDictionary: this.uploadedMetricDictionary,
      uploadedMetricRows: this.uploadedMetricRows,
      response: null,
    });
    this._snapshotInitialFormState();
    this.isFormDirty = false;
    return;
  }

  // New file selected — upload then emit
  const formData = this.buildAttributeImportanceFormData();

  this._configCustomService.uploadAttributeImportanceFile(formData).subscribe({
    next: (response) => {
      const metricEntriesArray = this.parseMetricRowsFromUploadResponse(response);
      this.uploadedMetricRows = metricEntriesArray;
      this.uploadedMetricDictionary = this.buildUploadedMetricDictionary(response);



      this.saveAdditionalColumnDetails.emit({
        selectedAdditionalColumnDetails: this.selectedAdditionalColumnDetails,
        additionalColumnForm: {
          columnHeader: this.additionalColumnHeader,
          columnPosition: this.additionalColumnPosition,
          hoverOverText: this.additionalColumnHoverText,
          positiveValue: this.additionalColumnPositiveValue,
          negativeValue: this.additionalColumnNegativeValue,
          sortingOrder: this.additionalColumnSortingOrder,
          combinationOfEntryPoints: this.combinationOfEntryPoints,
        },
        uploadedMetricDictionary: this.uploadedMetricDictionary,
        uploadedMetricRows: this.uploadedMetricRows,
        response,
      });
      
      this._snapshotInitialFormState();
      this.isFormDirty = false;
    },
    error: (error) => {
      console.error('Save failed', error);
    }
  });
}
  downloadAttributeImportanceTemplate(): void {
  this.isTemplateDownloadClicked = true;
  this._loaderService.showLoader();
    this._configCustomService.downloadAttributeImportanceTemplate(this.selectedAdditionalColumnDetails).subscribe({
      next: (blob: Blob) => {
        const fileName = 'AttributeImportanceTemplate.xlsx';
        const downloadUrl = window.URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = downloadUrl;
        anchor.download = fileName;
        anchor.click();
        window.URL.revokeObjectURL(downloadUrl);
           this._loaderService.hideLoader();
      },
      error: () => {
        this.errorPopup('Unable to download template at this time.', 'Error');
        this._loaderService.hideLoader();
      }
    });
     
  }
  downloadAttributeImportance(): void {
  if (!this.uploadedMetricRows || this.uploadedMetricRows.length === 0) {
    this.errorPopup('No uploaded data found. Please upload a file first.', 'Alert');
    return;
  }

  this._loaderService.showLoader();

  this._configCustomService
    .downloadAttributeImportance(
      this.selectedAdditionalColumnDetails?.snapshotId ?? '',
      this.uploadedMetricRows)
    .subscribe({
      next: (blob: Blob) => {
        const fileName = 'AttributeImportance.xlsx';
        const url = window.URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = fileName;
        anchor.click();
        window.URL.revokeObjectURL(url);
        this._loaderService.hideLoader();
      },
      error: () => {
        this.errorPopup('Unable to download file at this time.', 'Error');
        this._loaderService.hideLoader();
      }
    });
}
  onConfirmationPopUpCloseBtnClick(){
    this.showSubsctionPopup=false;
    this.closeSubsectionPopUp.emit({
      subsectionName:this.subsectionName,
      isValidated:false,
    });    
  }
  closeInputPopUpClick() {

    this.closeErrorPopUp.emit('false');
  }

  hoverBoldActive: boolean = false;
  hoverItalicActive: boolean = false;

  applyHoverTextFormat(tag: 'b' | 'i'): void {
    const el = this.hoverTextAreaRef?.nativeElement;
    if (!el) return;
    el.focus();
    document.execCommand(tag === 'b' ? 'bold' : 'italic', false, '');
    this.additionalColumnHoverText = el.innerHTML;
    this.updateHoverFormatState();
  }

  insertHoverLineBreak(): void {
    const el = this.hoverTextAreaRef?.nativeElement;
    if (!el) return;
    el.focus();
    document.execCommand('insertLineBreak', false, '');
    this.additionalColumnHoverText = el.innerHTML;
    this.updateHoverFormatState();
  }

  updateHoverFormatState(): void {
    try {
      this.hoverBoldActive = document.queryCommandState('bold');
      this.hoverItalicActive = document.queryCommandState('italic');
    } catch (e) {
      this.hoverBoldActive = false;
      this.hoverItalicActive = false;
    }
  }

  // onHoverTextInput(event: Event): void {
  //   const el = event.target as HTMLDivElement;
  //   this.additionalColumnHoverText = el.innerHTML;
  //   this.updateHoverFormatState();
  //   this.checkFormDirty();
  // }
   
  onHoverTextInput(event: Event): void {
  const el = event.target as HTMLDivElement;

  const plainText = el.innerText || '';

  if (plainText.length > 300) {
    el.innerText = plainText.substring(0, 300);

    const range = document.createRange();
    const sel = window.getSelection();

    range.selectNodeContents(el);
    range.collapse(false);

    sel?.removeAllRanges();
    sel?.addRange(range);
  }

  this.additionalColumnHoverText = el.innerHTML;

  this.updateHoverFormatState();
  this.checkFormDirty();
}

  closeSamplesizePopUpClick() {
    this.selectedweight = 'Sample Size';
    this.unWeightedBaseInput = true;
    this.weightedBaseInput = false;
    this.unWeightedNumeratorInput = false;
    this.weightedNumeratorInput = false
    this.closeSamplesizePopUp.emit('false');
  }
  closeConfirmationPopUpClick() {
    this.closeConfirmationPopUp.emit('false');
  }
  selectStudy(clientName: string, study: string, ClientCode: string) {
    /*if (this.isStudySelected == false) {*/

    this.selectedClient = clientName;
    this.selectedStudy = study;
    this.isNavigateButtonDisabled = false;
    this.isConfigurationButtonDisabled = false;
    this.isAddClientButtonDisabled = true;
    this.selectedClientCode = clientName;
    // this.isStudySelected = true;
    //}
    //else {
    //  this.selectedClient = "";
    //  this.selectedStudy = "";
    //  this.isNavigateButtonDisabled = true;
    //  this.isConfigurationButtonDisabled = true;
    //  this.isAddClientButtonDisabled = false;
    //  this.isStudySelected = false;
    //}
  }
  isSelected(clientName: string, study: string): boolean {
    // if (this.isStudySelected == true) {
    return this.selectedStudy === study;
    //}
    //else {
    //  return false;
    //}
  }
  filterData() {
    this.filteredData = this.popUpData.filter((client: Client) =>
      client.ClientName.toLowerCase().includes(this.searchText.toLowerCase())
    );
  }

  toggleStudies(clickedClient: any): void {
    // Close other clients if they are open
    this.popUpData.forEach((client: Client) => {
      if (client !== clickedClient) {
        client.showStudies = false;
      }
    });

    // Toggle the studies for the clicked client
    clickedClient.showStudies = !clickedClient.showStudies;
  }

  filterClients() {
    const lowerCaseSearchText = this.searchText.toLowerCase();
    return this.popUpData.filter((client: Client) =>
      client.ClientName.toLowerCase().includes(lowerCaseSearchText)
    );
  }
  addClientStudy() {
    this.router.navigateByUrl('configuration');
  }
  configuration() {
    let data: { client_name: string; study: string } = {
      client_name: this.selectedClient,
      study: this.selectedStudy,
    };
    this.router.navigateByUrl('configuration', { state: data });
  }
  navigate() {
    if (this.selectedClientCode === '' || this.selectedStudy === '') {
      this.router.navigateByUrl('landing');
    } else {
      let data: { client_code: string; study: string } = {
        client_code: this.selectedClientCode,
        study: this.selectedStudy,
      };
      this.router.navigateByUrl('Crosstab', { state: data });
    }
  }
  OnUserManagementClick() {
    this.router.navigateByUrl('user-management');
  }
  closeSavePopUp() {
    if (this.isSaveCustomGroupSelectionClick) {
      this.isSaveCustomGroupSelectionClick = false;
      this.showLoaderPopUp = false;
      this.SaveSelection = '';
      this.isCustomGroupSavePopUpVisible.emit({
        isClose: false,
      });
    } else {
      this.isSaveSelectionClick = false;
      this.showLoaderPopUp = false;
      this.SaveSelection = '';
      this.isSavePopUpVisible.emit({
        isClose: false,
      });
    }
  }

  closeCustomGroupPopUp() {
    this.isCustomGroupVisible.emit({
      isClose: false,
    });
  }

  closeCustomGroupSharePopUp() {

    this.isCustomGroupShareVisible.emit({
      isClose: false,
    });
  }

  closeShareSelectionPopUp(isShared: boolean = false) {
    this.isShareSelectionVisible.emit({
      isClose: false,
      isShared: isShared
    });
  }

  closeGlobalDefaultPopup() {
    if (this.dontShowAgain) {
      localStorage.setItem('dontShowGlobalDefaultPopup', 'true');
    }
    this.showGlobalDefaultPopup = false;
  }

  
  
  closeLoadPopUp() {
    this.isLoadClickOutput.emit('false');
    this.isLoadClick = false;
    this.showLoaderPopUp = false;
    this.showLoadSelection = false;
  }
  onOkBtnClick() {
    if (this.SaveSelection == '') {
      this.errorPopup('Selection name cannot be empty.');
    } else {
      this.SaveSelectionClick.emit({
        isValidationPass: true,
        selectionName: this.SaveSelection,
        isShareSelection: false, //this is for save selection
        selectionType: 'userDefined', //only user defined can be saved
      });
    }
  }

  onCustomOkBtnClick() {
    if (this.SaveSelection == '') {
      this.errorPopup('Custom Group Selection name cannot be empty.');
    } else {
      this.SaveCustomSelectionClick.emit({
        isValidationPass: true,
        selectionName: this.SaveSelection,
        isUpdate: false,
        isDuplicate: this.isDuplicateCustomGroup,
      });

      this.closePopUp.emit('false');
    }
  }

  onCreateBtn() {
    this.selectedCustomGroupName_Bucket = '';

    this.bindCustomGroupFlags.emit({
      displayMainComponent: false,
      isCreateCustomGroup: true,
      isUpdateCustomGroup: false,
      isDeleteCustomGroup: false,
      isDuplicateCustomGroup: false,
      isShareCustomGroup: false,
    });
    this.closePopUp.emit('false');

    //this.displayMainComponent=false;
  }

  onDeleteBtn() {
    this.updateSummary = [];
    this.bindCustomGroupFlags.emit({
      displayMainComponent: true,
      isUpdateCustomGroup: false,
      isCreateCustomGroup: false,
      isDeleteCustomGroup: true,
      isDuplicateCustomGroup: false,
      isShareCustomGroup: false,
      selectedCustomGroupName: this.selectedCustomGroupName,
      selectedCustomGroupName_Bucket: this.selectedCustomGroupName_Bucket,
      customGroupId: this.customGroupId,
    });
  }

  onDuplicateBtn() {
    this.bindCustomGroupFlags.emit({
      displayMainComponent: false,
      isUpdateCustomGroup: false,
      isCreateCustomGroup: false,
      isDeleteCustomGroup: false,
      isDuplicateCustomGroup: true,
      isShareCustomGroup: false,
      selectedCustomGroupName: this.selectedCustomGroupName,
      selectedCustomGroupName_Bucket: this.selectedCustomGroupName_Bucket,
      customGroupId: this.customGroupId
    });
  }

  onShareBtn() {
    //this.isShareCustomGroupPopupClick = true;

    //this.customGroupShareUserList = this.selectedCustomGroupObj.share_with;
    this.bindCustomGroupFlags.emit({
      displayMainComponent: true,
      isUpdateCustomGroup: false,
      isCreateCustomGroup: false,
      isDeleteCustomGroup: false,
      isDuplicateCustomGroup: false,
      isShareCustomGroup: true,
      selectedCustomGroupName: this.selectedCustomGroupName,
      selectedCustomGroupName_Bucket: this.selectedCustomGroupName_Bucket,
      customGroupId: this.customGroupId
    });
  }

  onUpdateBtn() {
    this.bindCustomGroupFlags.emit({
      displayMainComponent: false,
      isUpdateCustomGroup: true,
      isCreateCustomGroup: false,
      isDeleteCustomGroup: false,
      isDuplicateCustomGroup: false,
      isShareCustomGroup: false,
      selectedCustomGroupName: this.selectedCustomGroupName,
      selectedCustomGroupName_Bucket: this.selectedCustomGroupName_Bucket,
      customGroupId: this.customGroupId
    });

    // let listToUpdate = this.loadCustomGroupData.filter(
    //   (a: any) => a.selection_name === this.selectedCustomGroupName
    // );
    // JSON.parse(listToUpdate[0].selection_object); //listToUpdate[0].selection_object;
  }

  onShareSelectionClick() {
    this.shareSelectionUserList = this.selectedLoadSelectionObj.shared_with;
    this.selectedSelectionName = this.selectedLoadSelectionObj.selection_name;
    //this.selectedCustomGroupName_Bucket = 'User Defined'; //shared custom group cannot be shared again

    //append custom group name with _share if it is shared with some user for the 1st time
    var newSelectionName = this.selectedSelectionName;
    this.$unSubscribeSubmitData6 = this._configService
      .shareLoadSelection(
        this.selectedLoadSelectionObj.selection_name,
        this.selectedLoadSelectionObj.snapshotName,
        this.selectedLoadSelectionObj.snapshotType,
        this.selectedLoadSelectionObj.section,
        this.selectedLoadSelectionObj.subSection,
        this.selectedLoadSelectionObj.client_name,
        this.selectedLoadSelectionObj.study,
        this.selectedLoadSelectionObj.module_id,
        this.selectedEmailsToShare,
      )
      .subscribe((result: results) => {
        // Response is valid
        if (result.HasValidData) {
          let JsonData = JSON.parse(result.Data);
          if (JsonData == 'Shared Successfully') {

            //  //load main object
            // this.loadSharedWithMeSavedScenarioData.push(
            //   this.selectedLoadSelectionObj
            // );
            this.errorPopup('Shared Successfully', 'Alert');
            this.closeShareSelectionPopUp(true);
            // this.isShareSelectionClick = false;

          } else if (JsonData == 'Share Failed') {

            this.errorPopup('Share Failed. Please try again later', 'Alert');
            this.isShareSelectionClick = false;
          }
        }
        //hide the loader
        this.Loader.hideLoader();

        //this.usageDataLog(Feature.SaveQuery);
      });
  }

  onShareCustomGroups() {

    //if (this.selectedEmailsToShare.length == 0) {
    //  this.errorPopup('Please select email address.', 'Alert');
    //}
    //else {

    this.customGroupShareUserList = this.selectedCustomGroupObj.shared_with;
    this.selectedCustomGroupName = this.selectedCustomGroupObj.selection_name;
    this.selectedCustomGroupName_Bucket = 'userDefined'; //shared custom group cannot be shared again

    // //append custom group name with _share if it is shared with some user for the 1st time
    // var newCustomGroupName =
    //   this.customGroupShareUserList.length == 0
    //     ? this.selectedCustomGroupName
    //     : this.selectedCustomGroupName;
    this.$unSubscribeSubmitData6 = this.crossTabService
      .shareSelectedCustom(
        this.selectedCustomGroupObj.client_name,
        this.selectedCustomGroupObj.module_id,
        this.selectedCustomGroupObj.study,
        this.selectedCustomGroupName,
        this.selectedEmailsToShare,
        this.selectedCustomGroupObj.sortid,
        this.selectedCustomGroupObj.is_shared,
        'customGroup'
      )
      .subscribe((result: results) => {
        if (result.HasValidData) {
          let JsonData = JSON.parse(result.Data);
          if (JsonData == 'Shared Successfully')
            this.errorPopup('Custom Group Shared Successfully.', 'Alert');
          this.closeCustomGroupSharePopUp(); //triggrt popup close
          // this.isShareCustomGroupPopupClick=false;

          // this.isLoadClick = false; //close and reopen the popup to rebind the contents
          // this.isLoadClick = true;
        } else {
          this.errorPopup(
            'Custom Group Share has Failed. Please try again later.',
            'Alert'
          );
        }
      });
    //}
  }
  errorPopup(message: string, headerTxt: string = 'Error'): void {
    const alertObj: AlertMessageModel = {
      header: headerTxt,
      message: message,
      show: true,
    };
    this._alertService.showAlert(alertObj);
  }
  onKeyDown(event: KeyboardEvent): void {
    // Get the pressed key
    const pressedKey = event.key;

    // Allow alphanumeric characters, space, and backspace; prevent other keys

    //onst isValidKey = /^[A-Za-z0-9\s\-_]+$/.test(pressedKey);

    //const isValidKey = /^[^\s@]+$/.test(pressedKey);
    const isValidKey = /^[^\@]+$/.test(pressedKey) || pressedKey === ' ';

    if (!isValidKey) {
      event.preventDefault();
    }
  }

  isSharedAlready(email: string): boolean {
    return this.selectedEmailsToShare.includes(email);
  }
  toggleCustomGroupList(containerName: string) {
    if (containerName == 'userDefined') {
      this.isUserDefinedListVisible = !this.isUserDefinedListVisible;
      this.isSharedWithMeListVisible = false;
    } else if (containerName == 'Shared With Me') {
      this.isUserDefinedListVisible = false;
      this.isSharedWithMeListVisible = !this.isSharedWithMeListVisible;
    }
  }
  toggleSaveSelectionList(containerName: string) {
    if (containerName == 'userDefined') {
      this.isUserDefinedListVisible = !this.isUserDefinedListVisible;
      this.isSharedWithMeListVisible = false;
    } else if (containerName == 'Shared With Me') {
      this.isUserDefinedListVisible = false;
      this.isSharedWithMeListVisible = !this.isSharedWithMeListVisible;
    }
  }

  //on click of info icon bind user details towards left
  bindUserName(username: string) {
    this.updateSummary = [];
    username.split(',').forEach((element) => {
      var obj = {
        displayString: element,
      };
      this.updateSummary.push(obj);
    });

    this.customGroupHeaderText = 'Custom Email List';
  }

  handleLoadOptionsClick(
    columnName: string,
    row: any,
    scenarioType: string // user defined or shared with me
  ): void {
    this.currentSavedScenarioData.emit({ currentSavedScenarioData: row });
    if (columnName.toLowerCase() === 'load') {
      this.Loader.showLoader();

      this.$unSubscribeSubmitData6 = this._configService
        .getSavedScenarioData(
          row.study,
          row.client_name,
          row.snapshotName,
          row.snapshotType,
          row.section,
          row.subSection,
          row.selection_name,
          scenarioType,
          row.module_id
        )
        .subscribe((result: results) => {
          this.isLoadClickOutput.emit({
            isLoadClickOutput: false,
          });
          this.isLoadClick = false;

          this.showLoaderPopUp = false;
          // Response is valid
          if (result.HasValidData) {
            this.bindSelectedScenario.emit({
              selectedScenarioData: JSON.parse(result.Data),
            });
          }
          else {
            this.Loader.hideLoader();
          }
          //hide the loader
        });
    } else if (columnName.toLowerCase() === 'delete') {
      this.deleteMessage.emit({
        deleteMessage:
          'Confirm to delete "' + row.selection_name + '"  selection',
        selectionType: scenarioType,
      });

      this.isShowDialog.emit({ isShowDialog: true });
    } else if (columnName.toLowerCase() === 'info') {
      this.displayTable = false;
      this.infoMessage = row.selection_summary;
      // this.infoMessage.emit({ infoMessage: row.selectionSummary });
    } else if (columnName.toLowerCase() == 'share') {

      this.ShareSelectionClick.emit({
        isValidationPass: true,
        selectionName: row.selection_name,
        isShareSelection: true,
        selectionType: scenarioType,
        is_CustomGroup: row.is_CustomGroup,
      });

    }
  }

  bindBackClickEvent() {
    this.displayTable = true;
  }
  selected_client(selected_client: any, selected_study: any) {
    throw new Error('Method not implemented.');
  }
  selected_study(selected_client: any, selected_study: any) {
    throw new Error('Method not implemented.');
  }

  selectCustomGroup(selectionName: string, customGroupType: string, customGroupId: string) {
    this.updateSummary = [];

    var customGroupData;
    if (customGroupType == 'userDefined') {
      customGroupData = this.loadCustomGroupUserDefinedData;
    } else customGroupData = this.loadCustomGroupSharedWithMeData;

    let listToUpdate = customGroupData.filter(
      (a: any) => a.selection_name === selectionName
    );

    if (listToUpdate.length > 0) {
      var selectionObj = JSON.parse(listToUpdate[0].selection_object);
      this.updateSummary = selectionObj.customGroupSelectionsObj;

      this.selectedCustomGroupName = selectionName;
      this.selectedCustomGroupName_Bucket = customGroupType;
      this.customGroupId = customGroupId;
      this.customGroupHeaderText = 'Summary';
      // this.getCompleteCustomGroupInfo();
    }
  }

  showMatchingEmails(event: any): void {
    var userList;
    if (this.isShareSelectionClick) {
      // to share save selection
      userList = this.shareSelectionUserList;
    } //to share custom group
    else {
      userList = this.customGroupShareUserList;
    }
    const inputValue = event.target?.value?.toLowerCase().trim();
    if (inputValue) {
      this.filteredEmailsToShare = userList.filter((email: any) =>
        email.toLowerCase().includes(inputValue)
      );
      this.isUserListToShareDropdownOpen =
        this.filteredEmailsToShare.length > 0;
    } else {
      this.filteredEmailsToShare = [];
      this.isUserListToShareDropdownOpen = false;
    }
  }

  toggleSelectedEmail(email: string): void {
    const index = this.selectedEmailsToShare.indexOf(email);
    if (index === -1) {
      this.selectedEmailsToShare.push(email);
    } else {
      this.selectedEmailsToShare.splice(index, 1);
    }
  }

  Submit() {

  }


  images: any = [
    {
      name: "4 Widget Layout",
      url: "../../../../../assets/ImagesSnapshot/Public/fourWidget_inactive.png",
      activeurl: "../../../../../assets/ImagesSnapshot/Public/fourWidget_active.png",
      selected: true
    },
    {
      name: "6 Widget Layout",
      url: "../../../../../assets/ImagesSnapshot/Public/sixWidget_inactive.png",
      activeurl: "../../../../../assets/ImagesSnapshot/Public/sixWidget_active.png",
      selected: false
    }
  ]

  showDefaultSelectedWidget() {
    this.images.forEach((img: any) => {
      if (img.name == this.parentSelectedWidget) {
        img.selected = true;
      }
      else {
        img.selected = false;
      }
    });
  }

  isSelectedWidget(image: any) {
    this.images.forEach((img: any) => {
      if (img == image) {
        img.selected = true;
      }
      else {
        img.selected = false;
      }
    });
  }

  private _selectedwidget: any;
  @Input() parentSelectedWidget: any;
  @Output() selectedwidget = new EventEmitter<any>();
  SubmitWidget() {
    let imageselected = this.images.filter((img: any) => (img.selected == true));
    this.selectedwidget.emit(imageselected[0].name);
    // this.showLoaderPopUp=false;
    this.closePopUp.emit('false');
  }






  //ERROR POPUP
  // errorheaderTitle:string="Error";
  @Input() errorheaderTitle: any = "";
  @Input() infoheaderTitle: any = "";
  messageText: string = this.popUpMessage;
  @Input() buttonText: string = "Ok"
  showError: boolean = false;
  displayValue: string = "";
  heightValue: string = "";

  customcss(messageText: any) {
    if (messageText.length != 0) {
      if (messageText.length > 300) {
        this.heightValue = '100%';
        return '';
      }
      else {
        this.heightValue = '';
        return '';

      }
    }
    return '';
  }

  close() {
    this.showError = false;
  }
  onerrorPopUpOkBtnClick() {
    // this.showErrorPopUp=false;
    // this.showLoaderPopUp=false;
    this.closeErrorPopUp.emit('false');
  }


  @Input() reference: boolean = false;
  onConfirmationPopUpCancelBtnClick() {
    if(this.showConfirmationPopUp){
      this.closeErrorPopUp.emit('false');
    }
    this.showConfirmationPopUp = false;
    this.showErrorPopUp = false;
    if (this.reference) {
      this.closeErrorPopUp.emit('false');
    }
  }
  onConfirmationPopUpOkBtnClick() {
    // this.showErrorPopUp=false;
    // this.showLoaderPopUp=false;
    this.closeConfirmationPopUp.emit('false');
  }

    onSubSectionPopUpOkBtnClick() {
        // this.showErrorPopUp=false;
        // this.showLoaderPopUp=false;
        this.closeSubsectionPopUp.emit({
            subsectionName: this.subsectionName,
            isValidated: true,
        });
    }



  //Smaple size Popup related functions
  weightedBaseInput: boolean = false;
  unWeightedBaseInput: boolean = true;
  weightedNumeratorInput: boolean = false;
  unWeightedNumeratorInput: boolean = true;
  selectedweight:any;
  toggleWeights() {
    this.selectedweight ="Weighted Base";
    this.weightedBaseInput = true;
    this.unWeightedBaseInput = false;
    this.unWeightedNumeratorInput = false;
    this.weightedNumeratorInput = false
    // if (this.TrendToggleContainer) {
    //   this.TrendToggleOn = false;
    // }
  }

  toggleUnWeights() {
    this.selectedweight = 'Sample Size';
    this.unWeightedBaseInput = true;
    this.weightedBaseInput = false;
    this.unWeightedNumeratorInput = false;
    this.weightedNumeratorInput = false
    // if (this.TrendToggleContainer) {
    //   this.TrendToggleOn = false;
    // }
  }

  toggleNumeratorWeights() {
    this.selectedweight = 'Weighted Numerator';
    this.weightedBaseInput = false;
    this.unWeightedBaseInput = false;
    this.unWeightedNumeratorInput = false;
    this.weightedNumeratorInput = true
    // if (this.TrendToggleContainer) {
    //   this.TrendToggleOn = false;
    // }
  }

  toggleNumeratorUnWeights() {
    this.selectedweight = 'Unweighted Numerator';
    this.weightedBaseInput = false;
    this.unWeightedBaseInput = false;
    this.unWeightedNumeratorInput = true;
    this.weightedNumeratorInput = false
    // if (this.TrendToggleContainer) {
    //   this.TrendToggleOn = false;
    // }
  }

  TrendOnClick() {
    this.TrendToggleOn = true;

    let timePeriodLengths = Array.from(new Set(this._configService.standardSnapOutputData.map((item: any) => item.Level1ColChild))).length;
    if (timePeriodLengths == 1) {
      this.showErrorPopUp = true;
      this.errorheaderTitle = 'Alert';
      this.popUpMessage = 'There is only one time period for this selection.';
      this.buttonText = '';
    }

  }

  TrendOffClick() {
    this.TrendToggleOn = false;
  }
  
  invalidCharactersPattern =/[\/\\*?"<>|]/;
    onSubSectionNameChange(event:Event,isInputChange:boolean){
    const input = event.target as HTMLInputElement;
    if (input != null && input?.value != null) {
      if (this.invalidCharactersPattern.test(input.value)) {
        // Prevent the input if it contains invalid characters
        let eventItem: any = event.target
        eventItem.value = input.value.replace(this.invalidCharactersPattern, '');
        this.subsectionName = eventItem.value;
      }
      else {
        this.subsectionName = input.value;
      }
    }
  }



  onSaveSelectionOkBtnClick() {
    if (this.SaveSelection == '') {
      this.errorPopup('Selection name cannot be empty.');
    } else {
      this.SaveSelectionClick.emit({
        isValidationPass: true,
        selectionName: this.SaveSelection,
        isShareSelection: false, //this is for save selection
        selectionType: 'userDefined', //only user defined can be saved
      });
    }
  }

  selectDefaultLoadOption(event:Event,option: string, object: any, scenarioType: string) {
    event.stopPropagation();
    this.selectionName = option;
    if (scenarioType == 'userDefined') {
      this.loadSharedWithMeSavedScenarioData.forEach((row: any) => {
        row.shared_details[0].is_Shared_default = false;
      });
      this.loadUserDefinedSavedScenarioData.forEach((row: any) => {
        if (row.selection_name == option) {
          row.is_default = !row.is_default;
          this._configService.setDefaultLoadSelection(
            object.study,
            object.client_name,
            object.snapshotName,
            object.snapshotType,
            object.section,
            object.subSection,
            object.selection_name,
            scenarioType,
            object.module_id,
            row.is_default
          )
            .subscribe((result: results) => {
              
            })
        }
        else {
          row.is_default = false;
        }
      });

    }
    else {
      this.loadUserDefinedSavedScenarioData.forEach((row: any) => {
        row.is_default = false;
      });
      this.loadSharedWithMeSavedScenarioData.forEach((row: any) => {
        if (row.selection_name == option) {
          row.shared_details[0].is_Shared_default = !row.shared_details[0].is_Shared_default;
          this._configService.setDefaultLoadSelection(
            object.study,
            object.client_name,
            object.snapshotName,
            object.snapshotType,
            object.section,
            object.subSection,
            object.selection_name,
            scenarioType,
            object.module_id,
            row.shared_details[0].is_Shared_default
          )
            .subscribe((result: results) => {
              
            })
        }
        else {
          row.shared_details[0].is_Shared_default = false;
        }
      });
    }

  }

  OnViewDropDown() {
    this.showViewDropDown = !this.showViewDropDown;
  }

  OnBaseDropDown(){
    this.showBaseViewDropDown = !this.showBaseViewDropDown;
  }
  OnBaseSelected(baseData:any){

    if(this.dropDownBaseSelectedId == baseData.id){
      return;
    }
    if(baseData.id == 1){
      this.toggleUnWeights();
    }
    else if(baseData.id == 2){
      this.toggleWeights();
    }
    else if(baseData.id == 3){
      this.toggleNumeratorWeights();
    }
    else if(baseData.id == 4){
      this.toggleNumeratorUnWeights();
    }
    this.BaseDropDown.forEach((d:any) => {
      if(d.base != baseData.base)
        d.is_selected = false;
      else{
        d.is_selected = !d.is_selected;
        this.dropDownBaseSelectedName = d.base;
        this.dropDownBaseSelectedId = d.id;
      }
    })

  }

  OnViewSelected(dropdownText : any, dropdownId : any) {
    //this.defaultShowSampleSize = "Multiple"
    this.dropDownLevel1SelectedKey = dropdownText
    this.dropDownLevel1SelectedId = dropdownId;
    this.showViewDropDown = false;
    this.showLevel2DropDown = false;
    this.dropDownLevel2 = [];
    if( this.dropDownLevel1SelectedId == 0){
      this.dropDownLevel2SelectedValue = "Default View";
      this.dropDownLevel2SelectedValue = "Select"
      this.dropDownData = {
        dropDownLevel1: this.dropDownLevel1SelectedId,
        dropDownLevel2 : this.dropDownLevel2
      }
    }
    else if( this.dropDownLevel1SelectedId == 1){
      if(this.isAudienceType){
        // Audience: "All Audience for One Variable" - populate with metrics
        this.dropDownLevel2SelectedValue = "Select Variable"
        let distinctMetricName = [...new Set(this.MainData.map((item:any) => item.rowChild))]
        const showMetricGroup = this.hasMultipleMetricGroups(distinctMetricName);
        distinctMetricName.forEach( (metric:any)  => {
          let obj : any = {};
          obj.name = metric;
          obj.displayName = this.getMetricDisplayName(metric, showMetricGroup);
          obj.is_selected = false;
          this.dropDownLevel2.push(obj);
        })
      }else{
        this.dropDownLevel2SelectedValue = this._configService.selectedcompareacrossOption.replace(/\s+/g, '').toLowerCase() == "multiplemarkets"?"Select Market":"Select Brand"
        let distinctBrandNames = [...new Set(this.MainData.map((item:any) => item.colChild.split("|")[1]))]
          .filter((brand: any) => {
            const exclude = this._configService.getReferenceOnlyBrandToExcludeFromDisplay();
            return !exclude || brand !== exclude;
          });
        distinctBrandNames.forEach( brand => {
          let obj : any = {};
          obj.name = brand;
          obj.displayName = brand;
          obj.is_selected = false;
          this.dropDownLevel2.push(obj);
        })
      }
    }else{
      if(this.isAudienceType){
        // Audience: "All Variable for One Audience" - populate with audience values
        this.dropDownLevel2SelectedValue = "Select Audience"
        let distinctAudienceNames = [...new Set(this.MainData.map((item:any) => item.colChild.split("|").pop()))]
        distinctAudienceNames.forEach( (audience:any) => {
          let obj : any = {};
          obj.name = audience;
          obj.displayName = audience;
          obj.is_selected = false;
          this.dropDownLevel2.push(obj);
        })
      }else{
        this.dropDownLevel2SelectedValue = "Select Variable"
        let distinctMetricName = [...new Set(this.MainData.map((item:any) => item.rowChild))]
        const showMetricGroup = this.hasMultipleMetricGroups(distinctMetricName);
        distinctMetricName.forEach( (metric:any)  => {
          let obj : any = {};
          obj.name = metric;
          obj.displayName = this.getMetricDisplayName(metric, showMetricGroup); 
          obj.is_selected = false;
          this.dropDownLevel2.push(obj);
        })
      }
    }
  }
  private hasMultipleMetricGroups(metrics: any[]): boolean {
    const groups = new Set(
      metrics.map((metric: any) => {
        const firstPipe = metric.indexOf('|');
        return firstPipe > -1 ? metric.substring(0, firstPipe).trim() : '';
      })
    );
    return groups.size > 1;
  }
  private getMetricDisplayName(metric: any, showMetricGroup: boolean): string {
    const firstPipe = metric.indexOf('|');
    if (firstPipe === -1) {
      return metric;
    }
    const metricGroup = metric.substring(0, firstPipe).trim();
    const metricName = metric.substring(firstPipe + 1).trim();
    return showMetricGroup && metricGroup ? `${metricGroup} : ${metricName}` : metricName;
  }

  OnRadioModuleToggle(item:any){
    this.showViewDropDown = false;
    if(item && item.is_selected == true){
      return;
    }

    this.dropDownLevel2.forEach((d:any) => {
      if(item.name != d.name)
        d.is_selected = false;
      else{
        d.is_selected = !d.is_selected;
        this.dropDownLevel2SelectedValue = d.displayName;
      }
    })

    // if(item){
    //   item.is_selected = !item.is_selected
    // }

    this.dropDownData = {
      dropDownLevel1: this.dropDownLevel1SelectedId,
      dropDownLevel2 : this.dropDownLevel2
    }

  }

  ClickOnLevel2ViewDropDown(){
    this.showLevel2DropDown = !this.showLevel2DropDown
  }

  @HostListener('document:click', ['$event'])
  onOutsideClick(event: any): void {
    this.showViewDropDown = false;
    this.showLevel2DropDown = false;
    this.showBaseViewDropDown=false;
  }

  isSelectionChanged(): boolean {
    // Compare the selected items array based on the state of the checkboxes
    return JSON.stringify(this.selectedEmailsToShare) !== JSON.stringify(this.initialSelectedEmailsToShare);
  }

  /**
   * Filter output data using the hiddenCategories flag set by table1-component.
   * When table1-component hides a category (e.g. "Best Fit"), it stores it in
   * _configService.hiddenCategories. We use that list here to hide matching
   * NestedArray entries in the Sample Size popup table.
   * Also excludes reference-only brands (sig/index reference not in left-panel Brands)
   * from NestedArray only — do not drop the whole widget Row by Parent (Parent is often
   * just one representative brand; removing it wiped the entire Sample Size table).
   */
  filterOutputDataForNA(data: any): any {
    if (!data || !data.Row) {
      return data;
    }

    const hiddenCategories: string[] = this._configService.hiddenCategories || [];
    const referenceOnlyBrand =
      this._configService.getReferenceOnlyBrandToExcludeFromDisplay();

    if (hiddenCategories.length === 0 && !referenceOnlyBrand) {
      return data;
    }

    const filteredData = _.cloneDeep(data);

    filteredData.Row = filteredData.Row.filter((row: any) => {
      if (!referenceOnlyBrand) {
        return true;
      }
      // Multiple Brands Sample Size: brands live in NestedArray[].brand — keep the widget row.
      const hasBrandColumn = row.Data?.some((d: any) =>
        d.NestedArray?.some(
          (n: any) => n.brand != null && String(n.brand).trim() !== ''
        )
      );
      if (hasBrandColumn) {
        return true;
      }
      // Multi-cohort / one-row-per-brand: Parent is the brand colChild — drop reference-only rows.
      return !this._configService.shouldExcludeColChildFromDisplay(row?.Parent);
    });

    filteredData.Row.forEach((row: any) => {
      if (row.Data && Array.isArray(row.Data)) {
        row.Data.forEach((dataItem: any) => {
          if (dataItem.NestedArray && Array.isArray(dataItem.NestedArray)) {
            dataItem.NestedArray = dataItem.NestedArray.filter((nested: any) => {
              const child = (nested.Child || '').toLowerCase();
              // Hide if the NestedArray Child name matches any hidden category from table1-component
              if (
                hiddenCategories.some((cat) =>
                  child.includes(cat.toLowerCase())
                )
              ) {
                return false;
              }
              // Hide reference-only brand from the Brand column (match brand label only)
              if (
                referenceOnlyBrand &&
                this.isSameBrandLabel(nested.brand, referenceOnlyBrand)
              ) {
                return false;
              }
              return true;
            });
          }
        });
      }
    });

    return filteredData;
  }

  /** Compare brand labels ignoring optional "Brands|" prefix. */
  private isSameBrandLabel(
    value: string | null | undefined,
    brandName: string
  ): boolean {
    if (!value || !brandName) {
      return false;
    }
    const normalize = (b: string) =>
      (b || '').includes('|') ? b.split('|').pop()!.trim() : String(b).trim();
    return normalize(String(value)) === normalize(brandName);
  }
}

